import { ProductType } from '@inter-ikea-storageone/range';
export class RemoveDoorsAndLightsOnceInterceptor {
    constructor(productCatalog) {
        this.productDTOs = productCatalog.productDTOs();
        this.productCatalog = productCatalog;
    }
    beforeDeserialize(json) {
        return json;
    }
    beforeParsingComponents() { }
    beforeBuildingEntities(serializableTree) {
        serializableTree.entitiesArray().forEach(entity => {
            if (this.isDoorAssembly(entity) || this.isLight(entity)) {
                this.removeSerializableEntityAndDescendants(entity.id, serializableTree);
            }
        });
    }
    afterDeserializeComplete() {
        this.productCatalog.removeInterceptor(this);
    }
    getChildren(id, tree) {
        return tree.entitiesArray()?.filter(se => se.parent === id);
    }
    removeSerializableEntityAndDescendants(id, tree) {
        this.getChildren(id, tree).forEach(child => this.removeSerializableEntityAndDescendants(child.id, tree));
        tree.removeEntity(id);
    }
    findProductType(productRef) {
        return this.productDTOs.find((p) => p.id === productRef)?.type;
    }
    isDoorAssembly(serializableEntity) {
        const productType = this.findProductType(serializableEntity.ref);
        return (productType === ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM ||
            productType === ProductType.PAX_SLIDING_DOOR_REGULAR_ASM ||
            productType === ProductType.PAX_HINGE_DOOR_ASM);
    }
    isLight(serializableEntity) {
        const productType = this.findProductType(serializableEntity.ref);
        return (productType === ProductType.PAX_OUTER_LIGHT ||
            productType === ProductType.PAX_INNER_LIGHT ||
            productType === ProductType.PAX_INNER_LIGHT_OVERSIDAN ||
            productType === ProductType.LIGHT_CONTROLER ||
            productType === ProductType.LIGHT_CORD ||
            productType === ProductType.LIGHT_DRIVER);
    }
}
//# sourceMappingURL=RemoveDoorsAndLightsOnceInterceptor.js.map